import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const RefundPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="affiliate">
        <div className="container py-md-2 pt-2">
          <div className="row pt-md-5 justify-content-center">
            <div className="col-12 col-md-10 px-4">
              <div className="refund-eligibility">
                <h3 className="tc-head fw-bold pt-md-4 pb-md-2 py-3">
                  {t("rph8")}
                </h3>
                <p className="tc-text my-md-4 my-2">{t("rpp15")}</p>

                {/* <h2 className="tc-title fw-bold">{t("rph1")}</h2>

                <p className="tc-text my-md-4 my-2">{t("rpp1")}</p>
                <ul>
                  <li className="py-2 tc-text">{t("rpp2")}</li>
                  <li className="py-2 tc-text">{t("rpp3")}</li>
                  <li className="py-2 tc-text">{t("rpp4")}</li>
                </ul> */}

                <h5 className="tc-title fw-bold"> {t("rph2")}</h5>
                <h5 className="tc-title fw-bold  pt-4"> {t("rph21")}</h5>
                
                <ul className="py-2 ps-3 ps-md-3 ms-0 ms-md-3">
                  <li className="py-2 tc-text">
                    <strong style={{ "font-size": "18px" }}>
                      {t("rpp5").split(":")[0]}:{" "}
                    </strong>
                    {t("rpp5").split(":")[1]}
                  </li>
                  <li className="py-2 tc-text">
                    <strong style={{ "font-size": "18px" }}>
                      {t("rpp6").split(":")[0]}:{" "}
                    </strong>
                    {t("rpp6").split(":")[1]}
                  </li>
                  <li className="py-2 tc-text">
                    <strong style={{ "font-size": "18px" }}>
                      {t("rpp7").split(":")[0]}:{" "}
                    </strong>
                    {t("rpp7").split(":")[1]}
                  </li>
                  <li className="py-2 tc-text">
                    <strong style={{ "font-size": "18px" }}>
                      {t("rpp8").split(":")[0]}:{" "}
                    </strong>
                    {t("rpp8").split(":")[1]}
                  </li>
                </ul>
                <br />

                <h5 className="tc-title fw-bold">{t("rph3")}</h5>
                <ul className="py-2 ps-3 ps-md-3 ms-0 ms-md-3">
                  <li className="py-2 tc-text">
                    <strong style={{ "font-size": "18px" }}>
                      {t("rpp9").split(":")[0]}:{" "}
                    </strong>
                    {t("rpp9").split(":")[1]}
                  </li>
                  <li className="py-2 tc-text">
                    <strong style={{ "font-size": "18px" }}>
                      {t("rpp10").split(":")[0]}:{" "}
                    </strong>
                    {t("rpp10").split(":")[1]}
                  </li>
                </ul>

                {/* <h2 className="tc-title fw-bold">{t("rph4")}</h2>
                <p className="tc-text my-md-4 my-2">{t("rpp11")}</p>
                <h2 className="tc-title fw-bold"> {t("rph5")}</h2>
                <p className="tc-text my-md-4 my-2">{t("rpp12")}</p>

                <h2 className="tc-title fw-bold">{t("rph6")}</h2>
                <p className="tc-text my-md-4 my-2">{t("rpp13")}</p>
                <h2 className="tc-title fw-bold">{t("rph7")}</h2> */}
                <ul>
                  {" "}
                  <p className="tc-text my-md-4 my-2">{t("rpp16")}</p>
                  <br />
                  <p className="tc-text my-md-4 my-2">{t("rpp17")}</p>
                </ul>
              </div>
              <div className="refund-request my-3 p-md-5 p-3 text-center">
                <h5 className="refund-request-tilte fw-semibold px-md-5 balance py-4">
                  {t("rph9")}
                </h5>
                <Link
                  to={"/request-a-refund"}
                  className="btn refund-btn fw-bold mb-2"
                >
                  {t("rpb1")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RefundPolicy;
